import { getImg } from '@/utils/matchAsset'

const qrcode = getImg('match/pc/match/qrcode.jpg')

const boxDownload = require('../../assets/image/icon/xz.jpg')

export const matchFollowSectionData = {
  titleImage: getImg('match/pc/match/follow-title.png'),
  cardImage: getImg('match/pc/match/ss-1.png'),
  decorationImage: getImg('match/pc/match/ss-2.png'),
  items: [
    { id: 'box-download-1', label: '千年盒子下载', qrcode:boxDownload },
    { id: 'box-download-3', label: '抖音官方直播号①', qrcode:getImg('match/pc/match/dy.png') },
    { id: 'box-download-2', label: '抖音官方直播号②', qrcode:getImg('match/pc/match/dy2.png') },
  ],
}
